import { Data } from "../types/Data";
import { State } from "../types/State";

export class GroupLabel {
  #element: HTMLElement;
  #defaultLabel: string;
  #parser: (props: {
    state: State;
    data: Data;
    defaultLabel: string;
  }) => string;

  constructor(
    element: HTMLElement,
    parser: (props: {
      state: State;
      data: Data;
      defaultLabel: string;
    }) => string
  ) {
    this.#element = element;
    this.#defaultLabel = element.textContent as string;
    this.#parser = parser;
  }

  refresh(props: { state: State; data: Data }) {
    this.#element.textContent = this.#parser({
      ...props,
      defaultLabel: this.#defaultLabel,
    });
  }
}
